module.exports = __webpack_public_path__ + "de03284d49077c767434e789675fcf23.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/audios/500_l_70.mp3
// module id = 456
// module chunks = 0